import React from 'react';

const DetailsHeader = () => {
  return (
    <div className="col-lg-3 col-md-12">
      <div className="item tt">
        <div className="subtitle bigger without">Shall we work on a project together?</div>
      </div>
    </div>
  );
};

export default DetailsHeader;
